import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import '../Personnel/Employees.css';
import loadingSpinner from './../../assets/loading.gif';
import {CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {CreateTable} from './../ManageTable';
import axios from 'axios';
import {token, domain} from './../Security';
import { format } from 'date-fns';
// icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';

function SalaryComplaint({user, isHideSideMenu}) {
    var header = [
        "Name",
        "Position",
        "Site",
        "Payroll Period",
        "Types of Complaint",
        "Details",
        "",
    ]
    var accessor = [
        "fullName",
        "positionDescription",
        "locationDescription",
        "payrollPeriodDescription",
        "salaryComplaintDetail",
        "details",
        "manage"
    ]

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5", zIndex: 100000}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);

        const res = filterData.filter(
            f => (f.fullName ?? "")
                .toLowerCase()
                .includes(lowercaseValue)
        );

        setData(res);
    };

    //variables 
    const [email, setEmail] = useState(null);
    const [isMyself, setIsMyself] = useState(true);
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [position, setPosition] = useState(null);
    const [location, setLocation] = useState(null);

    const [typeOfComplaint, setTypeOfComplaint] = useState([])
    const [payrollPeriod, setPayrollPeriod] = useState(null)
    const [details, setDetails] = useState("")
    const [uploadedFile, setUploadedFile] = useState(null)

    const [formStep, setFormStep] = useState(1); // 1: Info, 2: Branching Logic
    const [isCertified, setIsCertified] = useState(false);
    const [selectedData, setSelectedData] = useState(null)

    const resetVariables = () => {
        setEmail(null);
        setIsMyself(true);
        setFirstName("");
        setMiddleName("");
        setLastName("");
        setContactNo("");
        setPosition(null);
        setLocation(null);
        setTypeOfComplaint([]);
        setPayrollPeriod(null)
        setDetails("")
        setUploadedFile(null)
        setFormStep(1)
        setIsCertified(false)
        setSelectedData(null)
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/SalaryComplaint";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    const fetchDataById = useCallback(async (_data) => {
        const apiUrl =  domain + "/api/SalaryComplaint";

        try {
            const response = await axios.get(`${apiUrl}/${_data.id}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const [showAddForm, setShowAddForm] = useState(false);
    const openAddForm = () => {
        setShowAddForm(true);
    }
    const closeAddForm = () => {
        setShowAddForm(false);
        resetVariables();
    }

    const handleAdd = async () => {
        const formattedComplaintDetails = typeOfComplaint.map(complaintName => ({
            type: complaintName
        }));

        const data = {
            email: email ?? "",
            isMyself: isMyself ?? false,
            firstName: firstName ?? "",
            middleName: middleName ?? "",
            lastName: lastName ?? "",
            contactNo: contactNo ?? "",
            positionId: position?.id ?? null,
            locationId: location?.id ?? null,
            salaryComplaintDetail: formattedComplaintDetails, 
            payrollPeriodId: payrollPeriod?.id ?? null,
            details: details ?? "",
            uploadedFile: uploadedFile?.base64 ?? null,
            createdBy: user?.id ?? null
        };

        const apiUrl =  domain + "/api/SalaryComplaint";

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoading(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
            closeAddForm();
        }
    };

    const [showUpdateForm, setShowUpdateForm] = useState(false);
    const openUpdateForm = () => {
        setShowUpdateForm(true);
    }
    const closeUpdateForm = () => {
        setShowUpdateForm(false);
        resetVariables();
    }

    const editHandleClick = async (_data) => {
        setLoading(true);

        const dataById = await fetchDataById(_data)
        setSelectedData(dataById)

        setEmail(dataById?.email ?? "");
        setIsMyself(dataById?.isMyself ?? true);
        setFirstName(dataById?.firstName ?? "");
        setMiddleName(dataById?.middleName ?? "");
        setLastName(dataById?.lastName ?? "");
        setContactNo(dataById?.contactNo ?? "");
        setPosition(dataById?.position ?? null);
        setLocation(dataById?.location ?? null);

        const complaintStrings = dataById?.salaryComplaintDetail?.map(item => item.type) ?? [];
        setTypeOfComplaint(complaintStrings);

        setPayrollPeriod(dataById?.payrollPeriod ?? null)
        setDetails(dataById?.details ?? "")

        const _uploadedFile = dataById.uploadedFile
            ? {
                base64: dataById.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                dataById.uploadedFile
                ),
                fileName: `Uploaded_File.${DetectMimeTypeFromBase64(
                dataById.uploadedFile
                ).split("/")[1]}`
            }
            : null

        setUploadedFile(_uploadedFile)

        openUpdateForm()
        setLoading(false);
    }

    const handleUpdate = async () => {
        const formattedComplaintDetails = typeOfComplaint.map(complaintName => ({
            type: complaintName
        }));

        const data = {
            email: email ?? "",
            isMyself: isMyself ?? false,
            firstName: firstName ?? "",
            middleName: middleName ?? "",
            lastName: lastName ?? "",
            contactNo: contactNo ?? "",
            positionId: position?.id ?? null,
            locationId: location?.id ?? null,
            salaryComplaintDetail: formattedComplaintDetails,
            payrollPeriodId: payrollPeriod?.id ?? null,
            details: details ?? "",
            uploadedFile: uploadedFile?.base64 ?? null,
            updatedBy: user?.id ?? null
        };

        const apiUrl =  domain + `/api/SalaryComplaint/update/${selectedData?.id}`;

        try {
            setLoading(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
            closeUpdateForm();
        }
    };

    const [showViewForm, setShowViewForm] = useState(false);
    const openViewForm = () => {
        setShowViewForm(true);
    }
    const closeViewForm = () => {
        setShowViewForm(false);
        resetVariables();
    }

    const viewHandleClick = async (_data) => {
        setLoading(true);

        const dataById = await fetchDataById(_data)
        setSelectedData(dataById)

        setEmail(dataById?.email ?? "");
        setIsMyself(dataById?.isMyself ?? true);
        setFirstName(dataById?.firstName ?? "");
        setMiddleName(dataById?.middleName ?? "");
        setLastName(dataById?.lastName ?? "");
        setContactNo(dataById?.contactNo ?? "");
        setPosition(dataById?.position ?? null);
        setLocation(dataById?.location ?? null);

        const complaintStrings = dataById?.salaryComplaintDetail?.map(item => item.type) ?? [];
        setTypeOfComplaint(complaintStrings);

        setPayrollPeriod(dataById?.payrollPeriod ?? null)
        setDetails(dataById?.details ?? "")

        const _uploadedFile = dataById.uploadedFile
            ? {
                base64: dataById.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                dataById.uploadedFile
                ),
                fileName: `Uploaded_File.${DetectMimeTypeFromBase64(
                dataById.uploadedFile
                ).split("/")[1]}`
            }
            : null

        setUploadedFile(_uploadedFile)

        openViewForm()
        setLoading(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Salary Module >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Salary Complaint"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Salary Complaint</h3>
                            </div>
                        </div>
                        <div className="employeesTab-body mt-1">
                            <div className="body-top row justify-between">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    "Search by name", 
                                                                    SearchIcon)}
                                </div>
                                <button className='bg-green-500 hover:bg-green-600 text-white rounded-sm border-none p-3 cursor-pointer'
                                    onClick={openAddForm}
                                >
                                    Add Complaint
                                </button>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={data}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    viewHandleClick={viewHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                {data.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- RELATIONSHIP DISCLOSURE MODAL --- */}
            {showAddForm && (
                <SalaryComplaintForm 
                    isOpen={showAddForm} onClose={closeAddForm}
                    email={email} setEmail={setEmail}
                    isMyself={isMyself} setIsMyself={setIsMyself}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    lastName={lastName} setLastName={setLastName}
                    contactNo={contactNo} setContactNo={setContactNo}
                    position={position} setPosition={setPosition}
                    location={location} setLocation={setLocation}
                    typeOfComplaint={typeOfComplaint} setTypeOfComplaint={setTypeOfComplaint}
                    payrollPeriod={payrollPeriod} setPayrollPeriod={setPayrollPeriod}
                    details={details} setDetails={setDetails}
                    uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
                    formStep={formStep} setFormStep={setFormStep}
                    isCertified={isCertified} setIsCertified={setIsCertified}
                    handleSubmit={handleAdd}
                />
            )}

            {/* --- RELATIONSHIP DISCLOSURE MODAL --- */}
            {showUpdateForm && (
                <SalaryComplaintForm 
                    isOpen={showUpdateForm} onClose={closeUpdateForm}
                    email={email} setEmail={setEmail}
                    isMyself={isMyself} setIsMyself={setIsMyself}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    lastName={lastName} setLastName={setLastName}
                    contactNo={contactNo} setContactNo={setContactNo}
                    position={position} setPosition={setPosition}
                    location={location} setLocation={setLocation}
                    typeOfComplaint={typeOfComplaint} setTypeOfComplaint={setTypeOfComplaint}
                    payrollPeriod={payrollPeriod} setPayrollPeriod={setPayrollPeriod}
                    details={details} setDetails={setDetails}
                    uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
                    formStep={formStep} setFormStep={setFormStep}
                    isCertified={isCertified} setIsCertified={setIsCertified}
                    handleSubmit={handleUpdate}
                />
            )}

            <SalaryComplaintViewModal
                isOpen={showViewForm}
                onClose={closeViewForm}
                email={email}
                isMyself={isMyself}
                firstName={firstName}
                middleName={middleName}
                lastName={lastName}
                contactNo={contactNo}
                position={position}
                location={location}
                typeOfComplaint={typeOfComplaint}
                payrollPeriod={payrollPeriod}
                details={details}
                uploadedFile={uploadedFile}
            />

            <GenerateMessage form={showRequestMessage}
                message={isSuccess ? "Request Success!" : requestMessage}
                isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                    <></>
                )
            }
        </div>
    )
}

const SalaryComplaintForm = ({
    isOpen, onClose,
    email, setEmail,
    isMyself, setIsMyself,
    firstName, setFirstName,
    middleName, setMiddleName,
    lastName, setLastName,
    contactNo, setContactNo,
    position, setPosition,
    location, setLocation,
    typeOfComplaint, setTypeOfComplaint, // Expecting array: []
    payrollPeriod, setPayrollPeriod,     // Expecting object: {from: '', to: ''}
    details, setDetails,
    uploadedFile, setUploadedFile,
    formStep, setFormStep,
    isCertified, setIsCertified,
    handleSubmit,
}) => {

    const complaintOptions = [
        "Overtime Pay", "Holiday Pay", "Food Allowance", "Undertime", "Absent",
        "SSS / PAG-IBIG / PhilHealth", "Withholding Tax", "Deduction",
        "Incorrect Salary Received vs Pay Slip", "No Salary Received"
    ];

    const handleCheckboxChange = (option) => {
        if (typeOfComplaint.includes(option)) {
            setTypeOfComplaint(typeOfComplaint.filter(item => item !== option));
        } else {
            setTypeOfComplaint([...typeOfComplaint, option]);
        }
    };

    const handleProceed = () => {
        if (formStep === 1) {
            if (!email || !firstName || !lastName || !position || !location) {
                return alert("Please input all required basic information.");
            }
        }
        
        if (formStep === 2) {
            if (typeOfComplaint.length === 0 || !payrollPeriod || !details) {
                return alert("Please fill up all complaint details.");
            }
        }

        if (formStep === 3) {
            if (!isCertified) return alert("Please check the certification.");
            handleSubmit();
            onClose();
        } else {
            setFormStep(prev => prev + 1);
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const maxSize = 10 * 1024 * 1024; // 10 MB

        if (file.size > maxSize) {
            alert("File size must not exceed 10 MB.");
            e.target.value = "";
            return;
        }

        const fileData = await HandleFileUpload(e);

        if (fileData) {
            setUploadedFile(fileData);
        }
    };

    const inputClass = "w-full border rounded-md p-2 border-gray-300 outline-none text-sm focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color";

    return (
        isOpen &&
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4" style={{ zIndex: "10000" }}>
            <div className="bg-white w-full max-w-2xl max-h-[90vh] flex flex-col rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
                
                {/* FIXED HEADER */}
                <div className="bg-[#668fca] p-6 text-white shrink-0">
                    <div className="flex justify-between items-start">
                        <div>
                            <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Salary Complaint</h2>
                            <span className="text-xs bg-blue-800 px-2 py-1 rounded mt-1 inline-block">
                                {`Step ${formStep} of 3`}
                            </span>
                        </div>
                        <button onClick={onClose} className="cursor-pointer border-none bg-transparent text-white hover:text-gray-200 text-2xl font-bold leading-none">&times;</button>
                    </div>
                </div>

                {/* SCROLLABLE BODY */}
                <div className="p-8 overflow-y-auto flex-1">
                    
                    {/* --- STEP 1: BASIC INFO --- */}
                    {formStep === 1 && (
                        <form className="space-y-6">
                            <div className="bg-gray-50 p-4 border border-gray-200 rounded text-xs text-gray-600">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="space-y-1">
                                        <p className="font-bold text-gray-800">⚠️ Reminders</p>
                                        <p>— Log in your individual / personal email</p>
                                        <p>— Incomplete submissions will not be accepted</p>
                                        <p>— HR will notify you if your request has been approved</p>
                                    </div>
                                    <div className="space-y-1">
                                        <p className="font-bold text-gray-800">📢 Cut-off for submissions</p>
                                        <p>— Every 10th: salary on 15th</p>
                                        <p>— Every 25th: salary on 31st</p>
                                        <p className="italic text-[10px] mt-1 text-blue-600">Note: submissions sent after the cut-off date will be processed for the next payroll period</p>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Email */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Email <span className="text-red-500">*</span></label>
                                <input type="email" required className="w-full p-2 placeholder-gray-400 outline-none bg-transparent border-none" style={{borderBottom: "1px solid gray"}} placeholder="yourname@email.com" value={email || ""} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            {/* Myself/Someone Else */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-3">Who are you filling up this form for? <span className="text-red-500">*</span></label>
                                <div className="flex gap-6">
                                    <label className="flex items-center cursor-pointer"><input type="radio" checked={isMyself} onChange={() => setIsMyself(true)} className="w-4 h-4 text-blue-600" /><span className="ml-2 text-sm text-gray-700">Myself</span></label>
                                    <label className="flex items-center cursor-pointer"><input type="radio" checked={!isMyself} onChange={() => setIsMyself(false)} className="w-4 h-4 text-blue-600" /><span className="ml-2 text-sm text-gray-700">Someone Else</span></label>
                                </div>
                            </div>
                            {/* Names */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div>
                                    <label className="block text-[10px] font-bold text-gray-500 uppercase">First Name</label>
                                    <input type="text" placeholder="JUAN" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray"}} value={firstName} onChange={(e) => setFirstName(e.target.value.toUpperCase())} />
                                </div>
                                <div>
                                    <label className="block text-[10px] font-bold text-gray-500 uppercase">Middle Name</label>
                                    <input type="text" placeholder="DELA" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray"}} value={middleName} onChange={(e) => setMiddleName(e.target.value.toUpperCase())} />
                                </div>
                                <div>
                                    <label className="block text-[10px] font-bold text-gray-500 uppercase">Last Name</label>
                                    <input type="text" placeholder="CRUZ" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray"}} value={lastName} onChange={(e) => setLastName(e.target.value.toUpperCase())} />
                                </div>
                            </div>
                            {/* Position/Location */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Contact Number</label>
                                    <input type="text" placeholder="09xxxxxxxx" className="w-full p-2 border-none outline-none" style={{borderBottom: "1px solid gray"}} value={contactNo} onChange={(e) => setContactNo(e.target.value)} />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Position <span className="text-red-500">*</span></label>
                                    <PositionSelect data={position} setData={setPosition} isEditable={true}/>
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Project / Site <span className="text-red-500">*</span></label>
                                <LocationSelect data={location} setData={setLocation} isEditable={true}/>
                            </div>
                        </form>
                    )}

                    {/* --- STEP 2: COMPLAINT DETAILS --- */}
                    {formStep === 2 && (
                        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <div className="bg-red-50 border border-red-200 p-3 rounded text-center">
                                <p className="text-red-600 font-bold text-sm">❗ READ FIRST ❗</p>
                                <p className="text-red-600 text-xs font-bold uppercase tracking-tight">DO NOT indicate your rate / salary here</p>
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Type of Complaint <span className="text-red-500">*</span></label>
                                <p className="text-[10px] text-gray-500 mb-3 italic">You can choose more than 1 if applicable</p>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                    {complaintOptions.map((opt) => (
                                        <label key={opt} className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded border border-gray-100 cursor-pointer">
                                            <input 
                                                type="checkbox" 
                                                checked={typeOfComplaint.includes(opt)} 
                                                onChange={() => handleCheckboxChange(opt)}
                                                className="w-4 h-4 text-blue-600"
                                            />
                                            <span className="text-xs text-gray-700">{opt}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Payroll Period <span className="text-red-500">*</span></label>
                                <PayrollPeriodSelect data={payrollPeriod} setData={setPayrollPeriod} isEditable={true}/>
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Details of Complaint/s <span className="text-red-500">*</span></label>
                                <p className="text-[10px] text-gray-500 mb-2 italic">Provide a concise but complete description of the issues related to your salary (e.g., missing overtime, incorrect deductions, etc.)</p>
                                <textarea 
                                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded outline-none focus:border-blue-500 text-sm" 
                                    rows="4"
                                    placeholder="Type details here..."
                                    value={details}
                                    onChange={(e) => setDetails(e.target.value)}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Documents / Pictures to Support Complaint</label>
                                <p className="text-[10px] text-red-500 font-bold uppercase mb-2">DO NOT indicate your rate / salary here</p>
                                <div className="flex flex-col gap-2 mt-1">
                                    <div className="flex items-center gap-2">
                                        {/* File Input – accept ANY file */}
                                        <input
                                            type="file"
                                            onChange={handleFileChange}
                                            className={`${inputClass} block w-full text-sm text-gray-500
                                                file:mr-4 file:py-2 file:px-4
                                                file:rounded file:border-0
                                                file:text-xs file:font-bold
                                                file:bg-gray-300 file:text-gray-700
                                                hover:file:bg-opacity-90 cursor-pointer`}
                                        /> 

                                        {/* Download / Check */}
                                        {uploadedFile && (
                                            <button
                                                type="button"
                                                onClick={() => DownloadFile(uploadedFile)}
                                                className="flex items-center gap-1 px-3 py-2 text-xs font-bold uppercase transition-colors rounded
                                                            text-white bg-green-500 hover:bg-green-600 hover:text-white"
                                                style={{border:"none"}}
                                                title="Download file"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-4 h-4"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                    />
                                                </svg>
                                                Check
                                            </button>
                                        )}
                                    </div>

                                    {/* File info */}
                                    {uploadedFile ? (
                                        <div className="text-[10px] text-green-600 font-medium">
                                            <p>
                                                {uploadedFile.fileName}
                                            </p>
                                            <p className="text-gray-500">
                                                {uploadedFile.contentType || "Unknown file type"}
                                            </p>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className="text-[10px] text-red-600 font-medium">
                                            <p>No file uploaded</p>
                                        </div>
                                    )
                                    }
                                </div>
                                <p className="text-[10px] text-gray-400 mt-1">Upload 1 supported file. Max 10 MB.</p>
                            </div>
                        </div>
                    )}

                    {/* --- FINAL STEP: CERTIFICATION --- */}
                    {formStep === 3 && (
                        <div className="space-y-6 animate-in fade-in duration-500">
                            <h4 className="font-bold text-gray-800 border-b pb-2 uppercase tracking-widest text-sm">Employee Certification</h4>
                            <div className="bg-gray-50 border-l-4 border-blue-500 p-6 space-y-4 text-gray-700 text-sm leading-relaxed text-justify">
                                <p>I hereby certify that the information provided in this <b>Salary Complaint Form</b> is accurate, complete, and truthful.</p>
                                <p>I understand that submission of this form does not automatically guarantee approval, and that my request will be reviewed and approved by management in accordance with company policies.</p>
                                <p>I acknowledge that providing any false, misleading, or incomplete information may result in disciplinary action, and I accept full responsibility for the accuracy of this request.</p>
                            </div>
                            <label className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg cursor-pointer border border-blue-200">
                                <input type="checkbox" checked={isCertified} onChange={(e) => setIsCertified(e.target.checked)} className="mt-1 w-5 h-5" />
                                <span className="text-sm font-bold text-blue-900">I confirm and agree to the certification and consent stated above.</span>
                            </label>
                        </div>
                    )}
                </div>

                {/* FIXED FOOTER */}
                <div className="p-6 border-t border-gray-100 flex justify-between items-center bg-gray-50">
                    <button type="button" onClick={formStep === 1 ? onClose : () => setFormStep(prev => prev - 1)} className="cursor-pointer border-none px-6 py-2 text-gray-600 font-bold hover:underline uppercase">
                        {formStep === 1 ? "CANCEL" : "BACK"}
                    </button>

                    <button 
                        type="button"
                        onClick={handleProceed}
                        className={`cursor-pointer border-none px-10 py-2 text-white font-bold rounded shadow-lg transition-all 
                            ${(formStep === 3 && !isCertified) ? "bg-gray-300" : "bg-[#668fca] hover:bg-blue-600"}`}
                    >
                        {formStep === 3 ? "SUBMIT COMPLAINT" : "NEXT"}
                    </button>
                </div>
            </div>
        </div>
    )
}
const SalaryComplaintViewModal = ({
    isOpen,
    onClose,
    email,
    isMyself,
    firstName,
    middleName,
    lastName,
    contactNo,
    position,
    location,
    typeOfComplaint,
    payrollPeriod,
    details,
    uploadedFile,
}) => {
    if (!isOpen) return null;

    // Helper to display labels and values
    const DataField = ({ label, value, fullWidth = false }) => (
        <div className={`py-2 ${fullWidth ? "md:col-span-2" : ""}`}>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
            <p className="text-sm font-medium text-gray-800 uppercase">{value || "—"}</p>
        </div>
    );

    // Helper to format Date
    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 z-[10000]">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] flex flex-col rounded-lg shadow-2xl overflow-hidden border border-gray-200">
                
                {/* HEADER / BANNER */}
                <div className="bg-[#668fca] p-8 text-white shrink-0 relative">
                    <div className="absolute top-4 right-4">
                        <button onClick={onClose} className="cursor-pointer border-none bg-transparent text-white hover:text-gray-200 text-2xl font-bold leading-none">&times;</button>
                    </div>
                    <h2 className="text-2xl font-black uppercase tracking-tighter">Salary Complaint Form</h2>
                    <p className="text-blue-100 text-xs font-bold uppercase tracking-widest mt-1">Don Lee Builders Inc. — HR Compliance</p>
                </div>

                {/* DOCUMENT BODY */}
                <div className="p-10 overflow-y-auto flex-1 bg-white">
                    
                    {/* SECTION 1: DISCLOSER INFORMATION */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            I. Complainant Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                            <DataField label="Full Name" value={`${lastName}, ${firstName} ${middleName || ""}`} />
                            <DataField label="Filling for" value={isMyself ? "Self" : "Someone Else"} />
                            <DataField label="Email Address" value={email} />
                            <DataField label="Contact Number" value={contactNo} />
                            <DataField label="Position" value={position?.Description || position?.description} />
                            <DataField label="Project / Site" value={location?.Description || location?.description} />
                        </div>
                    </section>

                    {/* SECTION 2: COMPLAINT CATEGORY */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            II. Complaint Details
                        </h3>
                        <div className="space-y-4">
                            <div>
                                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Type of Complaint</p>
                                <div className="flex flex-wrap gap-2">
                                    {typeOfComplaint && typeOfComplaint.length > 0 ? (
                                        typeOfComplaint.map((type, idx) => (
                                            <span key={idx} className="bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full text-xs font-bold">
                                                {type}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-gray-400 text-sm">No types selected</span>
                                    )}
                                </div>
                            </div>

                            <DataField 
                                label="Payroll Period Involved" 
                                value={payrollPeriod ? `${formatDate(payrollPeriod.DateFrom || payrollPeriod.dateFrom)} — ${formatDate(payrollPeriod.DateTo || payrollPeriod.dateTo)}` : "—"} 
                            />
                            
                            <div className="mt-4 bg-gray-50 p-4 rounded border border-gray-200">
                                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Detailed Narrative</p>
                                <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{details || "No specific details provided."}</p>
                            </div>
                        </div>
                    </section>

                    {/* SECTION 3: SUPPORTING DOCUMENTS */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            III. Evidence & Attachments
                        </h3>
                        {uploadedFile ? (
                            <div className="flex items-center justify-between p-4 border border-green-100 bg-green-50 rounded-lg">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-green-500 rounded text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-sm font-bold text-green-800 truncate max-w-xs">{uploadedFile.fileName}</p>
                                        <p className="text-[10px] text-green-600 uppercase font-medium">{uploadedFile.contentType}</p>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => DownloadFile(uploadedFile)}
                                    className="cursor-pointer px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-[10px] font-bold uppercase rounded transition-colors"
                                >
                                    Download File
                                </button>
                            </div>
                        ) : (
                            <div className="p-4 border border-dashed border-gray-200 rounded-lg text-center">
                                <p className="text-xs text-gray-400 font-medium italic">No supporting documents were uploaded with this complaint.</p>
                            </div>
                        )}
                    </section>

                    {/* FOOTER CERTIFICATION TEXT */}
                    <div className="mt-12 pt-8 border-t border-gray-100 text-[11px] text-gray-400 italic text-justify leading-relaxed">
                        This document serves as a formal complaint submission. The employee has certified that the information provided is accurate and understands that submission does not guarantee automatic approval. This data is protected under company privacy policies and is used solely for payroll investigation and correction.
                    </div>
                </div>

                {/* MODAL FOOTER */}
                <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
                    <button 
                        onClick={onClose}
                        className="cursor-pointer bg-gray-800 hover:bg-black text-white px-8 py-2 rounded text-xs font-black tracking-widest uppercase transition-all shadow-md"
                    >
                        Close Document
                    </button>
                </div>
            </div>
        </div>
    );
};

const PositionSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Position/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    {_data.map(({ id, description }) => (
                    <option key={id} value={id} className='text-gray-700'>
                        {`${description}`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const LocationSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Location/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    {_data.map(({ id, description }) => (
                    <option key={id} value={id} className='text-gray-700'>
                        {`${description}`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const PayrollPeriodSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/PayrollPeriod/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    {_data.map((item, index) => (
                    <option key={index} value={item.id} className='text-gray-700'>
                        {`${format(item.dateFrom, 'MM/dd/yyyy')} - ${format(item.dateTo, 'MM/dd/yyyy')} (${item.payTypeDescription ?? "UNDEFINED-PAYTYPE"})`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const HandleFileUpload = (e) => {
    return new Promise((resolve, reject) => {
        const file = e.target.files?.[0];
        if (!file) {
            resolve(null);
            return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];

        resolve({
                base64: base64String,
                fileName: file.name,
                contentType: file.type,
            });
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
    });
};
const DownloadFile = (value) => {
    const fileData = value;
    if (!fileData) return;

    const { base64, fileName, contentType } = fileData;

    const linkSource = `data:${contentType};base64,${base64}`;
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = fileName; // 👈 keeps original filename & extension
    downloadLink.click();
};
const DetectMimeTypeFromBase64 = (base64) => {
    if (!base64) return "application/octet-stream";

    const signatures = {
        "/9j/": "image/jpeg",
        "iVBORw0KGgo": "image/png",
        "R0lGOD": "image/gif",
        "JVBERi0": "application/pdf",
        "UEsDB": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
        "0M8R4KGx": "application/vnd.ms-excel", // xls
        "UEsDBBQABgA": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    };

    for (const signature in signatures) {
        if (base64.startsWith(signature)) {
            return signatures[signature];
        }
    }

    return "application/octet-stream"; // true fallback
};

export default SalaryComplaint
